import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { initInstallPromptCapture } from "@/lib/pwaInstall";

// Suppress ResizeObserver loop error - this is a known benign error
// that occurs with UI libraries like Radix/Shadcn and doesn't affect functionality
const resizeObserverErr = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    e.stopImmediatePropagation();
  }
};
window.addEventListener('error', resizeObserverErr);

// PWA-Installations-Event global abfangen (nur einmal & sehr früh verfügbar),
// damit die Installation jederzeit über Einstellungen ausgelöst werden kann.
initInstallPromptCapture();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

// Service Worker für PWA-Installierbarkeit & Offline-Fallback registrieren
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
